import { ITokenData } from '../../../../rest/oauth';
import { Status } from 'use-timer/lib/types';
import { LensesExperienceValues } from '../../../common/lenses-experience-form/lenses-experience-form.models';
import { CaptchaParams } from '../../../../graphql/configuration';

export interface IRegistrationProps {
  onDone: (stepsState: IStepsState) => void;
  externalState: IExternalStateProps;
}

export interface IExternalStateProps {
  time: number;
  reset: () => void;
  start: () => void;
  status: Status;
  captcha: CaptchaParams;
}

export interface IStepsState {
  phone: TPhoneValues;
  confirmationCode: TConfirmationCodeValues;
  name: TNameValues;
  lensesExperience: LensesExperienceValues;
  email: TEmailValues;
  password: TPasswordValues;
}

export type TPhoneValues = {
  formValues: TPhoneFormValues;
  token: ITokenData;
};

export type TPhoneFormValues = {
  phoneNumber: string;
};

export type TConfirmationCodeValues = {
  otpCode: string;
};

export type TNameValues = {
  firstName: string;
  lastName: string;
};

export type TPasswordValues = {
  pin: string;
  authoriseJnj: boolean;
  marketing: boolean;
  tnc: boolean;
  phoneCall?: boolean;
};

export type TEmailValues = {
  formValues: TEmailFormValues;
  token: ITokenData;
};

export type TEmailFormValues = {
  email: string;
};

export enum RegistrationErrorCodes {
  emailExist = 'SY.REGISTRATION_002',
}
